import { render, staticRenderFns } from "./SecurePaymentInvalid.vue?vue&type=template&id=804da678"
import script from "./SecurePaymentInvalid.vue?vue&type=script&lang=js"
export * from "./SecurePaymentInvalid.vue?vue&type=script&lang=js"
import style0 from "./SecurePaymentInvalid.vue?vue&type=style&index=0&id=804da678&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports